<template>
    <div v-if="store.state.isModalOpenThree" class="modal fade show my-2" aria-labelledby="addNewCardTitle" style="display: block; background: #1c1d1c33">
        <div class="modal-dialog modal-lg modal-dialog-centered" ref="modalRef">
            <div class="modal-content">
                <div class="row">
                    <div class="col-12">
                        <div class="d-flex justify-content-between px-1 my-1 align-item-center">
                          <h1 class="mb-0">Job Apply</h1>
                            <button
                                @click="onClickClose"
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            ></button>
                        </div>
                    </div>
                </div>

                <hr class="mt-0 mb-0">

              <div class="px-3 mb-2 pt-2">
                <p class="text-danger fw-bolder">
                  Before submitting your application, please make sure your profile is up to date so we can evaluate your application accurately.
                </p>
              </div>

              <div class="px-3">
                <ul class="list-group mb-3">
                  <li class="list-group-item"><strong>Name:</strong> {{ user.name }}</li>
                  <li class="list-group-item"><strong>Email:</strong> {{ user.email }}</li>
                  <li class="list-group-item"><strong>Phone:</strong> {{ user.phone }}</li>
                </ul>
              </div>

              <div class="px-3 pb-3">
                <div class="mb-3">
                  <label for="expectedSalary" class="form-label">Expected Salary</label>
                  <input type="number" step="any" v-model="formData.expected_salary"  class="form-control" id="expectedSalary" placeholder="Enter your expected salary">
                </div>

                <div class="mb-3">
                  <label for="currentSalary" class="form-label">Current Salary</label>
                  <input type="number" step="any" v-model="formData.current_salary"  class="form-control" id="currentSalary" placeholder="Enter your current salary">
                </div>

                <div class="mb-3">
                    <div class="mb-2">
                      <label for="attachment" class="form-label fw-bold">Upload CV(Only PDF)</label>
                      <BlobFileViewer :attachments="formData.attachment"/>
                      <FileUpload
                          :is-drag-active="true"
                          button-text="Upload CV(Only PDF)"
                          v-model="formData.attachment"
                          :maxFiles="1"
                      >
                      </FileUpload>
                    </div>
                </div>

                <button class="btn btn-primary" @click="handleSubmit" :disabled="loading">
                  Submit Application
                </button>
              </div>

            </div>
        </div>
        <Loader v-if="loader"/>

    </div>
</template>

<script setup>
import Loader from "@/components/atom/LoaderComponent";
import {computed, inject, ref} from "vue";
import { useStore } from "vuex";
import { useRoute } from 'vue-router';
import handleHrPayroll from "@/services/modules/hrPayroll/hrPayroll";
import FileUpload from "@/components/atom/FileUpload.vue";
import BlobFileViewer from "@/components/atom/BlobFileViewer.vue";

const props = defineProps({
  job: {
    type: Object,
    default: {}
  }
})
const emit = defineEmits(['singleJob']);
const store = useStore();
const $route = useRoute();
const modalRef = ref(null);
const loader = ref(false);
const loading = ref(false);
const showError = inject('showError');
const showSuccess = inject('showSuccess');
const user = computed(() => store.state.user.user)

const formData = ref({
  expected_salary: null,
  current_salary: null,
  attachment: [],
})

const {
  createJobApplication,
} = handleHrPayroll();

const handleSubmit = async() => {
  loading.value = true;
  const copyFormData = new FormData();
  copyFormData.append('expected_salary', formData.value.expected_salary)
  copyFormData.append('current_salary', formData.value.current_salary)
  copyFormData.append('job_requisition_id',  props.job.id)
  copyFormData.append('company_id',  props.job.company_id)
  const attachments = formData.value.attachment;

  attachments.forEach((attachment) => {
    if (attachment && attachment instanceof File && attachment.type != 'application/pdf') {
      showError("Please upload your CV in PDF format only.");
      return
    }
    if (attachment && attachment instanceof File && attachment.type === 'application/pdf') {
      copyFormData.append('attachments[]', attachment);
    }
  });

  createJobApplication(copyFormData)
      .then(res => {
        if (!res.status) {
          showError(res.message)
          return
        }
        showSuccess(res.message)
        emit('singleJob')
        onClickClose()
      })
      .catch(err => {
        console.log(err)
      }).finally(() => {
         loading.value = false
  })
}

const onClickClose = () => {
  store.state.isModalOpenThree = false;
}

</script>
